import React, { useEffect, useRef, useState } from "react";
import {
  AdvSeparator,
  Avatar,
  Backdrop,
  Button,
  DetailCard,
  DropdownMenuNew,
  DualIcon,
  FormFieldSet,
  InfoCircle,
  InfoTextAdv,
  LogoLoader,
  Modal,
  Skeleton,
  SmartTooltip,
  TableAdv,
  showToast,
} from "../../../../components";
import { mapTableRows } from "../../../../utils";
import { Link } from "react-router-dom";
import JobsAccordion from "./JobsAccordion";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAllJobs,
  fetchAllJobsStart,
  updateBdmJobs,
} from "../../../../redux/slices/bdmjobs/bdmjobsSlice";
import {
  addNoteApi,
  fetchAllNotes,
  fetchAllRecruitersAndBDMUsers,
  fetchAllSubmissions,
  fetchNoActivityJobs,
  fetchTalentMatch,
  jobsTableFilter,
  updateJobPostStatus,
  userRefCount,
  addLeadCompany,
  addLeadJob,
  getLeadCompany,
  fetchAllLeadJobs,
  updateLeadJob,
  updateLeadCompany,
} from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import { usePagination } from "../../../../hooks";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import AddJobPost from "../../AccountDetails/AccountDetail/Modals/AddJobPost";
import { getBdmSettingsApi, getAllIntegrations, getAllIntegrationAccess } from "../../../../redux/slices/setting/settingApi";
import { getRaSettingsStart } from "../../../../redux/slices/leads/leadsSlice";
import { setBdmSettings } from "../../../../redux/slices/setting/settingsSlice";
import ExpiringJobs from "./Modals/ExpiringJobs";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { formatWords2 } from "../../../../utils/stringUtils";

const AllJobs = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [statusChangeModal, setStatusChangeModal] = useState(false);
  const [statusChangeDate, setStatusChangeDate] = useState(null);
  const [selectedModalRows, setSelectedModalRows] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [editModal, setEditModal] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [botConfirmModal, setBotConfirmModal] = useState(false);
  const [pendingBotAssignment, setPendingBotAssignment] = useState(null);
  

  // Lead capture modal
  const [leadCaptureModal, setLeadCaptureModal] = useState(false);
  const [leadCaptureRow, setLeadCaptureRow] = useState(null);
  const [leadCaptureStatus, setLeadCaptureStatus] = useState(null);
  const [leadCompanyName, setLeadCompanyName] = useState("");
  const [leadLinkedInUrl, setLeadLinkedInUrl] = useState("");
  const [leadAssignedTo, setLeadAssignedTo] = useState("");
  const [leadUrlError, setLeadUrlError] = useState("");
  const [leadSubmitting, setLeadSubmitting] = useState(false);
  const [companyAlreadyExists, setCompanyAlreadyExists] = useState(false);
  const [existingCompanyUiid, setExistingCompanyUiid] = useState(null);
  const [checkingCompany, setCheckingCompany] = useState(false);
  const [existingLeadJobUiid, setExistingLeadJobUiid] = useState(null);
  const [interviewDate, setInterviewDate] = useState(null);
  const [interviewDateError, setInterviewDateError] = useState("");


  const { user } = useSelector((state) => state?.auth);
  const dispatch = useDispatch();
  const jobs = useSelector((state) => state?.bdmJobs?.allJobs?.data);
  const pageLoading = useSelector((state) => state?.bdmJobs?.loading);
  const bdmSettings = useSelector(
    (state) => state?.settings?.generalSettings?.bdmSettings,
  );
  const raSettings = useSelector((state) => state.leads?.raSettings?.data);
  
  const expiringJobsDisplayedOn = useSelector(
    (state) => state?.bdmJobs?.expiringJobsDisplayedOn,
  );
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );
  const { value } = useSelector((state) => state?.totalCount);
  const orgId = user?.data?.organizationId?.uiid;
  // const totalCount = value || 0;
  const [totalCount, setTotalCount] = useState(value?.allJobsPosts?.data || 0);
  const [loading, setLoading] = useState(false);
  const [allRecruiters, setAllRecruiters] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [filteredJobs, setFilteredJobs] = useState(null);
  const [activeFilters, setActiveFilters] = useState(null);

  const [selectedRows, setSelectedRows] = useState([]);
  const [showDataId, setShowDataId] = useState([]);
  const [isNotePanelOpen, setIsNotePanelOpen] = useState(false);
  const [showSingleNotes, setShowSingleNotes] = useState(false);
  const [note, setNote] = useState("");
  const [jobPostIds, setJobPostIds] = useState([]);
  const [notes, setNotes] = useState([]);
  const [notesLoading, setNotesLoading] = useState(false);
  const [accordionData, setAccordionData] = useState({});
  const [accordionLoading, setAccordionLoading] = useState({});
  const [expiringJobs, setexpiringJobs] = useState();
  const [isExpiringJobsModel, setIsExpiringJobsModel] = useState(false);
  const [noteId, setNoteId] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [maximumCalls,setMaximumCalls] = useState();
  

  const debounceRef = useRef(null);

  // console.log(showDataId)
  // console.log(jobPostIds)
  const currencyMap = {
    1: "USD",
    2: "INR",
  };

  const OPERATOR_MAP = {
    equal: "EQUAL",
    notEqual: "EXCLUDE",
    contains: "CONTAINS",
    notContains: "NOT_CONTAINS",
    startsWith: "STARTS_WITH",
    endsWith: "ENDS_WITH",
    greaterThan: "GT",
    lessThan: "LT",
    greaterThanOrEqual: "GTE",
    lessThanOrEqual: "LTE",
  };

  const COLUMN_MAP = {
    jobTitle: "jobId.title",
    code: "jobInfo.jobCode",
    companyName: "companyId.name",
    // jobLocation: "jobInfo.location", // doubt
    jobStatus: "currentStatus",
    clientBill: "jobInfo.payments.billRate.amount",
    payBill: "jobInfo.payments.payRate.amount",
    deliveryManager: "assignedTo.firstName",
    recruiter: "notifyTo.firstName",
    jobCreatedBy: "addedBy.firstName",
    jobCreatedOn: "addedOn",
    minSalary: "jobInfo.payments.payRate.amount.min",
    maxSalary: "jobInfo.payments.payRate.amount.max",
  };

  // Statuses that require lead capture before applying
  const LEAD_CAPTURE_STATUSES = [2, 5, 6, 7, 11, 12];

  const employmentTypeMap = {
    1: "1099",
    2: "C2C",
    3: "C2C",
    4: "Full Time",
    5: "In-cop",
    6: "Intern",
    7: "Other",
    8: "Part Time",
    9: "W-2",
  };

  const toggleAccordion = (rowId, accordionType) => {
    setExpandedRows((prev) => {
      if (prev[rowId] === accordionType) {
        const newState = { ...prev };
        delete newState[rowId];
        return newState;
      }
      return { ...prev, [rowId]: accordionType };
    });
  };

  const formatPayment = (payment) => {
    if (!payment) return "";

    const currency = currencyMap[payment?.currency] || "USD";

    let amount = "";
    if (payment?.amount != null && typeof payment?.amount === "object") {
      amount = `${payment?.amount?.min || ""}-${payment?.amount?.max || ""}`;
    } else if (payment?.amount != null) {
      amount = payment?.amount;
    }

    const freq = payment?.freqType || "";
    const empType = employmentTypeMap[payment?.employmentType] || "";

    return [currency, amount, freq, empType].filter(Boolean).join("/");
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    const optionsDate = { year: "numeric", month: "long", day: "2-digit" };
    const formattedDate = date.toLocaleDateString("en-US", optionsDate);

    const optionsTime = {
      hour: "2-digit",
      minute: "2-digit",
      // second: "2-digit",
      hour12: true,
    };
    const formattedTime = date.toLocaleTimeString("en-US", optionsTime);

    return `${formattedDate} ${formattedTime}`;
  };

  const truncateText = (text, limit = 17) => {
    if (!text) return "";
    return text.length > limit ? text.slice(0, limit) + "..." : text;
  };

  const timeCalc = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (seconds < 60) return `${seconds}s ago`;
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    if (days < 7) return `${days}d ago`;
    if (weeks < 5) return `${weeks}w ago`;
    if (months < 12) return `${months}mo ago`;
    return `${years}y ago`;
  };

  const validateLinkedInCompanyUrl = (url) => {
    if (!url?.trim()) return "LinkedIn company URL is required.";
    const trimmed = url.trim();
    if (!/^https?:\/\//i.test(trimmed)) return "URL must start with https://";
    if (!/linkedin\.com/i.test(trimmed))
      return "URL must be a LinkedIn URL (linkedin.com).";
    if (/linkedin\.com\/jobs/i.test(trimmed))
      return "Job listing URLs are not allowed. Please enter a company profile URL (e.g. https://www.linkedin.com/company/your-company).";
    if (/linkedin\.com\/in\//i.test(trimmed))
      return "Personal profile URLs are not allowed. Please enter a company profile URL.";
    if (
      /linkedin\.com\/(posts|pulse|feed|search|school|groups|events)/i.test(
        trimmed,
      )
    )
      return "Only LinkedIn company profile URLs are accepted (e.g. https://www.linkedin.com/company/your-company).";
    if (
      !/^https?:\/\/(www\.)?linkedin\.com\/company\/[a-zA-Z0-9\-._~%]+\/?(\?.*)?$/.test(
        trimmed,
      )
    )
      return "Invalid LinkedIn company URL. Please Enter Correct Company URL";
    return "";
  };

  const validateInterviewDate = (date, newStatus, statusHistory = []) => {
    if (!date) return "Interview date is required.";

    const selected = new Date(date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selected < today) return "Interview date cannot be in the past.";

    const getLastDateForStatus = (status) => {
      const entries = (statusHistory || []).filter((h) => h?.status === status);
      if (!entries.length) return null;
      return new Date(entries[entries.length - 1]?.addedOn);
    };

    if (newStatus === 6) {
      const l1Date = getLastDateForStatus(5);
      if (!l1Date) return "Interview L1 must be scheduled before Interview L2.";
      if (selected <= l1Date)
        return "Interview L2 must be scheduled after Interview L1.";
    }

    if (newStatus === 7) {
      const l2Date = getLastDateForStatus(6);
      if (!l2Date) return "Interview L2 must be scheduled before Interview L3.";
      if (selected <= l2Date)
        return "Interview L3 must be scheduled after Interview L2.";
    }

    return "";
  };
  const scheduleInterviewCols = [
    {
      key: "sNo",
      label: "S.No",
    },
    {
      key: "name",
      label: "Name",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => <div className="text-info-500">{row?.name}</div>,
    },
    {
      key: "email",
      label: "Email ID",
    },
    {
      key: "phone",
      label: "Phone number",
    },
    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "experience",
      label: "Experience (In years)",
    },
    {
      key: "workAuth",
      label: "Work Authorization",
    },
    {
      key: "location",
      label: "Location",
    },
  ];
  const scheduleInterviewRows = Array.from({ length: 5 }, (_, index) => ({
    id: index + 1,
    sNo: index + 1,
    name: "Jack Raison",
    email: "jackrai@gmail.com",
    phone: "9876543210",
    jobTitle: "Frontend Developer",
    experience: 3,
    workAuth: "USA",
    location: "Dallas",
  }));

  const getSubmissionCounts = (submissions = []) => {
    const counts = { shortlisted: 0, pipeline: 0, submission: 0 };

    (submissions || []).forEach((sub) => {
      const lastStatus =
        sub?.statusHistory?.[sub?.statusHistory?.length - 1]?.status;

      if (lastStatus === 1) counts.shortlisted += 1;
      else if (lastStatus === 2) counts.pipeline += 1;
      else if (lastStatus === 3) counts.submission += 1;
    });

    return counts;
  };

  const onlineStatus = [true, false];

  const initialJobs = (jobs || []).map((job, index) => {
    const submissionCounts = getSubmissionCounts(job?.submissions || []);

    return {
      id: index,
      uiid: job?.uiid,
      icons: "",
      code: job?.jobInfo?.jobCode || "",
      jobTitle: formatWords2(job?.jobId?.title || ""),
      companyName: job?.jobId?.companyId?.name
        ? formatWords2(job?.jobId?.companyId?.name)
        : "N/A",

      jobLocation: job?.jobInfo?.location
        ? [
            job?.jobInfo?.location?.city,
            job?.jobInfo?.location?.state,
            job?.jobInfo?.location?.country,
          ]
            .filter(Boolean)
            .join(", ")
        : "N/A",
      jobStatus: job?.jobId?.status,
      contact: Math.floor(Math.random() * 6),
      online: onlineStatus[Math.floor(Math.random() * 2)],
      applications: job?.talentMatch?.ids?.length || 0,
      shortlisted: submissionCounts?.shortlisted,
      pipelined: submissionCounts?.pipeline,
      // submitted: submissionCounts?.submission,
      submitted: job?.submissions?.length,
      submissions: job?.submissions || [],
      clientBill: formatPayment(job?.jobInfo?.payments?.billRate),
      payBill: formatPayment(job?.jobInfo?.payments?.payRate),
      deliveryManager: formatWords2(job?.assignedTo?.firstName) || "-",
      jobCreatedBy: formatWords2(job?.addedBy?.firstName),
      jobCreatedOn: job?.addedOn
        ? formatDateTime(convertFromUTC(job?.addedOn))
        : "",
      minSalary: job?.jobInfo?.payments?.payRate?.amount?.min || 0,
      maxSalary: job?.jobInfo?.payments?.payRate?.amount?.max || 0,
      notes: job?.notes || [],
      statusHistory: job?.statusHistory || [],
      recruiter: job?.notifyTo || "-",
      talentMatchIds: job?.talentMatch?.ids || [],
      aiRecruiter: job?.aiRecruiter || null,
      jobUrl: job?.jobId?.description || "",
      canEdit:
        user?.data?.role?.type === 3 && job?.addedBy?.uiid === user?.data?.uiid,
    };
  });

  const [jobStatuses, setJobStatuses] = useState(
    initialJobs.reduce((acc, job) => {
      acc[job.id] = job?.jobStatus;
      return acc;
    }, {}),
  );

  const JobPostingStatus = {
    // 1: "Draft",
    2: "Active",
    3: "On Hold",
    4: "Hold by Client",
    5: "Interview L1",
    6: "Interview L2",
    7: "Interview L3",
    8: "Priority",
    9: "Filled",
    10: "Closed",
    11: "Agreement Sent",
    12: "Agreement Accepted",
  };
  const statusOptions = Object.entries(JobPostingStatus).map(
    ([value, label]) => ({
      value: Number(value),
      label,
    }),
  );

  const [recruiter, setRecruiter] = useState(
    initialJobs.reduce((acc, job) => {
      // acc[job.id] = job.recruiter;
      acc[job?.uiid] = job?.recruiter;
      return acc;
    }, {}),
  );

  useEffect(() => {
    if (totalCount == 0) {
      dispatch(clearAllJobs());
    }
  }, [dispatch, totalCount, searchValue]);

  useEffect(() => {
    if (jobs && jobs.length > 0) {
      const newRecruiterState = jobs.reduce((acc, job) => {
        acc[job.uiid] = job?.notifyTo || [];
        return acc;
      }, {});
      setRecruiter(newRecruiterState);
    }
  }, [jobs]);

  useEffect(() => {
    dispatch(getRaSettingsStart({ coll: "Setting" }));
  }, [dispatch]);

  

  useEffect(() => {
    if (!leadCaptureModal || !leadCompanyName) return;

    const checkCompanyExists = async () => {
      try {
        setCheckingCompany(true);

        // 1. Check if company exists or not
        const companyRes = await getLeadCompany({
          coll: "LeadCompany",
          ret: "uiid name assignedTo",
          fil: { name: { type: "NONE", value: leadCompanyName.trim() } },
        });

        const companies = companyRes?.data?.data || [];
        const matchedCompany = companies.find(
          (c) =>
            c?.name?.toLowerCase().trim() ===
            leadCompanyName.toLowerCase().trim(),
        );

        if (matchedCompany?.uiid) {
          setCompanyAlreadyExists(true);
          setExistingCompanyUiid(matchedCompany.uiid);

          if (user?.data?.role?.type === 1 && matchedCompany?.assignedTo) {
            const assignedUiid = matchedCompany.assignedTo;
            const matched = allRecruiters.find((r) =>
              r.value.endsWith(`-${assignedUiid}`),
            );
            if (matched) {
              setLeadAssignedTo(matched);
            }
          }

          // 2. Company exists, check if LeadJob exists or not
          try {
            const jobRes = await fetchAllLeadJobs({
              coll: "LeadJob",
              lim: 50,
              pg: 1,
              ret: "uiid jobTitle companyId status",
              fil: JSON.stringify({
                companyId: { type: "NONE", value: matchedCompany.uiid },
              }),
              app: "ats",
            });

            const leadJobs = jobRes?.data?.data || [];
            const matchedJob = leadJobs.find(
              (j) =>
                j?.jobTitle?.toLowerCase().trim() ===
                (leadCaptureRow?.jobTitle || "").toLowerCase().trim(),
            );

            if (matchedJob?.uiid) {
              setExistingLeadJobUiid(matchedJob.uiid);
            } else {
              setExistingLeadJobUiid(null);
            }
          } catch {
            setExistingLeadJobUiid(null);
          }
        } else {
          setCompanyAlreadyExists(false);
          setExistingCompanyUiid(null);
          setExistingLeadJobUiid(null);
        }
      } catch (err) {
        console.error("Company check failed:", err);
        setCompanyAlreadyExists(false);
        setExistingCompanyUiid(null);
        setExistingLeadJobUiid(null);
      } finally {
        setCheckingCompany(false);
      }
    };

    checkCompanyExists();
  }, [leadCaptureModal, leadCompanyName]);

  const handleSelectionChange = (rows) => {
    setSelectedRows(rows);
    const ids = rows
      .map((rowId) => initialJobs.find((job) => job?.id === rowId)?.uiid)
      .filter(Boolean);
    setJobPostIds(ids);
  };

  const colJobDetails = [
    {
      key: "icons",
      label: "",
      width: "min-w-[200px]! max-w-[350px]!",
      render: (row) => {
        const contactEmpty = row?.contact > 0;

        return (
          <div className="flex items-center gap-2">
            <div>
              <DropdownMenuNew
                MenuSection={
                  <div className="flex flex-col">
                    {row?.canEdit && (
                      <Button
                        title={"Edit"}
                        variant="text"
                        color="black"
                        size="xs-sm"
                        className="!justify-start py-2"
                        // onClick={() => setEditModal(true)}
                        onClick={() => {
                          setSelectedJobId(row?.uiid);
                          setEditModal(true);
                        }}
                      />
                    )}
                    <Button
                      title={"Publish"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-1"
                    />
                    <Button
                      title={"Schedule Interview"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-2"
                      onClick={() => setScheduleModal(true)}
                    />

                    <Button
                      title={"Compose Mail"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-2"
                      onClick={() => setIsModalOpen(true)}
                    />
                  </div>
                }
              >
                <Button
                  icon={"more_vert"}
                  variant="text"
                  type="icon"
                  size="sm"
                  color="black"
                />
              </DropdownMenuNew>
            </div>
            <div>
              <Button
                type="icon"
                icon={"contacts"}
                color={contactEmpty ? "success" : "gray-500"}
                variant="text"
              />
            </div>
            <div
              className={`w-3 h-3 rounded-full ${
                row.online ? "bg-success" : "bg-gray-200"
              }`}
            ></div>
            <div className="flex items-center gap-2">
              {row?.applications > 0 && (
                // <div
                //   onClick={() => {
                //     toggleAccordion(row.id, "applications");
                //     handleFetchTalentMatch(row);
                //   }}
                // >
                <SmartTooltip description="Talent Match" noicon>
                  <InfoCircle
                    color="invoiced"
                    colorDepth="100"
                    className="text-white"
                    value={row?.applications}
                    prefix={"+"}
                    noBorder
                    size="xs"
                    onClick={() => {
                      toggleAccordion(row.id, "applications");
                      // handleFetchTalentMatch(row);
                    }}
                  />
                </SmartTooltip>
                // </div>
              )}

              {row?.shortlisted > 0 && (
                // <div
                //   // onClick={() => toggleAccordion(row.id, "shortlisted")}
                //   onClick={() => {
                //     toggleAccordion(row.id, "shortlisted");
                //     handleFetchSubmissions(row, "shortlisted");
                //   }}
                // >
                <SmartTooltip description="Shortlisted" noicon>
                  <InfoCircle
                    className="text-white"
                    value={row?.shortlisted}
                    prefix={"+"}
                    noBorder
                    size="xs"
                    onClick={() => {
                      toggleAccordion(row.id, "shortlisted");
                      // handleFetchSubmissions(row, "shortlisted");
                    }}
                  />
                </SmartTooltip>
                // </div>
              )}
              {row?.pipelined > 0 && (
                // <div
                //   // onClick={() => toggleAccordion(row.id, "pipelined")}
                //   onClick={() => {
                //     toggleAccordion(row.id, "pipelined");
                //     handleFetchSubmissions(row, "pipelined");
                //   }}
                // >
                <SmartTooltip description="Pipeline" noicon>
                  <InfoCircle
                    color="gray"
                    colorDepth="800"
                    className="text-white"
                    value={row?.pipelined}
                    prefix={"+"}
                    noBorder
                    size="xs"
                    onClick={() => {
                      toggleAccordion(row.id, "pipelined");
                      // handleFetchSubmissions(row, "pipelined");
                    }}
                  />
                </SmartTooltip>
                // </div>
              )}
              {row?.submitted > 0 && (
                // <div
                //   // onClick={() => toggleAccordion(row.id, "submitted")}
                //   onClick={() => {
                //     toggleAccordion(row.id, "submitted");
                //     handleFetchSubmissions(row);
                //   }}
                // >
                <SmartTooltip description="Submission" noicon>
                  <InfoCircle
                    color="info"
                    className="text-white"
                    value={row?.submitted}
                    prefix={"+"}
                    noBorder
                    size="xs"
                    onClick={() => {
                      toggleAccordion(row.id, "submitted");
                      // handleFetchSubmissions(row);
                    }}
                  />
                </SmartTooltip>
                // </div>
              )}
            </div>
            {row?.notes && row?.notes.length > 0 && (
              <div>
                {/* <Button
                type="icon"
                icon={"mark_unread_chat_alt"}
                variant="text"
                color="warning"
                onClick={() => {
                  if (!selectedRows.includes(row.id)) {
                    setSelectedRows([...selectedRows, row.id]);
                  }
                  setShowDataId([row.id]);
                  setShowSingleNotes(true);
                }}
              /> */}
                <DualIcon
                  size="sm"
                  badgeIconColor={
                    row?.notes?.length > 0 ? "bg-success" : "bg-dark"
                  }
                  // onClick={() => {
                  //   if (!selectedRows.includes(row.id)) {
                  //     setSelectedRows([...selectedRows, row.id]);
                  //   }
                  //   setShowDataId([row.id]);
                  //   setShowSingleNotes(true);
                  //   setIsNotePanelOpen(false);
                  //   setNoteId(row?.uiid)
                  //   handleFetchNotes(row);
                  // }}
                  onClick={() => {
                    const newSelected = [row?.id];
                    setSelectedRows(newSelected);

                    const ids = newSelected
                      .map(
                        (rId) =>
                          initialJobs.find((job) => job?.id === rId)?.uiid,
                      )
                      .filter(Boolean);
                    setJobPostIds(ids);

                    setShowDataId([row?.id]);

                    setShowSingleNotes(true);
                    setIsNotePanelOpen(false);

                    setNoteId(row?.uiid);

                    handleFetchNotes(row);
                  }}
                />
              </div>
            )}
          </div>
        );
      },
    },
    {
      key: "code",
      label: "Job Code",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <Link
          to={`/ats/jobs/job-details`}
          className="text-info"
          state={{ uiid: row?.uiid }}
          onClick={() => {
            sessionStorage.setItem("selectedJobUiid", row?.uiid);
            sessionStorage.setItem(
              "prevJobsPage",
              window.location.pathname + window.location.search,
            );
          }}
        >
          {row?.code}
        </Link>
        // <Link to={`/ats/jobs/job-details/${row.uiid}`} className="text-info">
        //   {row.code}
        // </Link>
      ),
    },
    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[230px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.jobTitle}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.jobTitle}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "companyName",
      label: "Company Name",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.companyName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.companyName}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "jobLocation",
      label: "Job Location",
      render: (row) => (
        <SmartTooltip
          description={formatWords2(row?.jobLocation) != "-" ? formatWords2(row?.jobLocation) : "N/A"}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{formatWords2(row?.jobLocation) != "-" ? formatWords2(row?.jobLocation) : "N/A"}</div>
        </SmartTooltip>
      ),
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "jobStatus",
      label: "Job Status",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => {
        const lastStatus =
          row?.statusHistory && row?.statusHistory?.length > 0
            ? row?.statusHistory[row?.statusHistory?.length - 1]?.status
            : 2;
        const currentOption =
          statusOptions.find((opt) => opt.value === lastStatus) ||
          statusOptions.find((opt) => opt.value === 2);

        return (
          <div className="w-[180px] min-w-[160px]">
            <FormFieldSet
              type="select"
              noTitle
              size="sm"
              options={statusOptions}
              value={currentOption}
              showSearch
              onChange={(opt) => handleStatusChange(opt, row)}
              // showButton
            />
          </div>
        );
      },
    },
    {
      key: "clientBill",
      label: "Client Bill",
      width: "min-w-[180px]! max-w-[220px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.clientBill}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.clientBill}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "payBill",
      label: "Pay Bill",
      width: "min-w-[180px]! max-w-[220px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.payBill}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.payBill}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "deliveryManager",
      label: "Delivery Manager",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.deliveryManager}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.deliveryManager}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "recruiter",
      label: "Recruiter",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => {
        const recruiterData = recruiter[row?.uiid] || [];
        // console.log("recruiterData", recruiterData);
        const recruiterOption = recruiterData
          .filter((r) => r && r.uiid)
          .map((r) => ({
            label: r.firstName,
            value: `${r.firstName} ${r.lastName}-${r.uiid}`,
          }));

        return (
          <div className="w-[180px] min-w-[160px]">
            <FormFieldSet
              // type="AllRecruiters"
              type="select"
              placeholder="Select"
              noTitle
              size="sm"
              multiple
              showSearch
              options={allRecruiters}
              value={recruiterOption}
              onChange={(opt) => handleRecruiterChange(opt, row)}
            />
          </div>
        );
      },
    },
    {
      key: "jobCreatedBy",
      label: "Job Created By",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "jobCreatedOn",
      label: "Job Created On",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.jobCreatedOn}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.jobCreatedOn}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "minSalary",
      label: "Min Salary",
      width: "min-w-[150px]! max-w-[200px]!",
    },
    {
      key: "maxSalary",
      label: "Max Salary",
      width: "min-w-[150px]! max-w-[200px]!",
    },
  ];

  const rowJobDetails = initialJobs.map((job) => ({
    ...job,
    jobStatus: jobStatuses[job.id],
  }));

  // const mappedRowsJobDetails = mapTableRows(rowJobDetails, colJobDetails);
  const tableData = filteredJobs ?? rowJobDetails;
  const mappedRowsJobDetails = mapTableRows(tableData, colJobDetails);

  const handleDelete = (id) => {
    setShowDataId((data) => data.filter((item) => item !== id));
    setSelectedRows((row) => row.filter((item) => item !== id));
    setJobPostIds((prevIds) => {
      // Find the uiid of the deleted job
      const deletedJob = initialJobs.find((job) => job?.id === id);
      if (deletedJob?.uiid) {
        return prevIds.filter((uiid) => uiid !== deletedJob.uiid);
      }
      return prevIds;
    });
  };

  const rowData = rowJobDetails.filter((item) =>
    selectedRows.includes(item.id),
  );

  

  const handleNoteAdd = async () => {
    if (!note?.trim()) {
      showToast("Note cannot be empty", "error", 2000);
      return;
    }
    // const targetJobIds = showSingleNotes ? showDataId : jobPostIds;
    //  console.log(targetJobIds)
    const targetJobIds = jobPostIds;
    if (!targetJobIds.length) {
      showToast("No job selected", "error", 2000);
      return;
    }
    let notesRes = null;
    try {
      setLoading(true);
      if (targetJobIds.length > 1) {
        let successCount = 0;
        let failCount = 0;
        for (const id of targetJobIds) {
          const res = await addNoteApi({
            coll: "Note",
            postActions: ["updateSource"],
            payload: {
              addedBy: user?.data?.uiid,
              jobPostId: id,
              note,
              source: 1, // 1 for JobPosting
              priority: 3, // low priority by default
            },
          });
          if (res?.data) {
            successCount++;
          } else {
            failCount++;
          }
        }
        if (successCount === 0) {
          showToast("Failed to add notes", "error", 2000);
          return;
        }
        if (failCount > 0) {
          showToast(
            `Added ${successCount} notes, ${failCount} failed`,
            "warning",
            3000,
          );
        }
      }
      // for (const id of jobPostIds) {
      else {
        notesRes = await addNoteApi({
          coll: "Note",
          postActions: ["updateSource"],
          payload: {
            addedBy: user?.data?.uiid,
            jobPostId: targetJobIds[0],
            note,
            source: 1, // 1 for JobPosting
            priority: 3, // low priority by default
          },
        });
        if (!notesRes?.data) {
          showToast("Failed to add note", "error", 2000);
          return;
        }
      }
      //}
      //  console.log(notesRes?.data?.data?.uiid)
      showToast("Note added", "success", 2000);
      // const data = notesRes?.data?.data
      // dispatch(updateJobNotes({
      //   jobPostIds: [data?.jobPostId],
      //   newNote: {
      //     addedBy: user?.data?.uiid,
      //     jobPostId: targetJobIds[0],
      //     note,
      //     uiid: data?.uiid, // This will be used
      //     addedOn: new Date().toISOString(),
      //     // Add other note properties as needed
      //   }
      // }))
      setNote("");
      dispatch(
        fetchAllJobsStart({
          coll: "JobPosting",
          lim: limit,
          pg: page,
          // ret: "uiid jobInfo jobId addedOn addedBy statusHistory",
          ret: "uiid jobInfo jobId addedOn addedBy statusHistory notes submissions notifyTo assignedTo talentMatch",
          // ref: "Job Note Submission",
          // ref: "Job",
          ref: "Job Submission",
          fil: { "statusHistory.status": { type: "EXCLUDE", value: 1 } },
          extret: "uiid firstName",
          incl: ["", "uiid statusHistory.status"],
          sort: { addedOn: -1 },
        }),
      );
      //if (showSingleNotes && targetJobIds.length === 1) {
      // console.log(jobs)
      if (noteId) {
        const updatedJob = jobs?.find(
          (job) => job.uiid === noteId, //targetJobIds[0]
        );
        //console.log([...updatedJob.notes,noteId])
        if (updatedJob?.notes?.length > 0) {
          const res = await fetchAllNotes({
            coll: "Note",
            ret: "uiid note addedBy addedOn",
            fil: {
              uiid: {
                type: "IN",
                value: [...updatedJob?.notes, notesRes?.data?.data?.uiid],
              },
            },
            extret: "uiid firstName",
          });
          setNotes(res.data?.data || []);
          // console.log(updatedJob.notes )
        } else {
          setNotes([]);
        }
      } else {
        setShowSingleNotes(false);
        setIsNotePanelOpen(false);
      }
    } catch (err) {
      console.error("Error adding note:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleFetchNotes = async (job) => {
    // console.log(job)
    if (!job?.notes || job?.notes?.length === 0) {
      showToast("No notes found for this job", "info", 2000);
      return;
    }
    // console.log(job)
    try {
      setNotesLoading(true);
      const res = await fetchAllNotes({
        coll: "Note",
        // pg: 1,
        // lim: 50,
        ret: "uiid note addedBy addedOn",
        fil: { uiid: { type: "IN", value: job?.notes || [] } },
        extret: "uiid firstName",
      });

      // console.log("Fetched Notes:", res.data.data);
      // setNotes(res.data.data || []);
      if (res?.data) {
        // console.log(res?.data)
        setNotes(res?.data?.data || []);
      } else {
        setNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
      setNotesLoading(false);
    }
  };

  const handleFetchSubmissions = async (job, type = "submitted", pg = 1, lim = 10) => {
    try {
      setAccordionLoading((prev) => ({ ...prev, [job?.uiid]: true }));
      const submissionIds = (job?.submissions || [])
        .map((sub) => (typeof sub === "object" ? sub?.uiid : sub))
        .filter(Boolean);
      let fil = {
        uiid: { type: "IN", value: submissionIds || [] },
      };
      if (type !== "submitted") {
        fil["statusHistory.status"] = {
          type: "ARRAY_LAST_TWO_FIELDS_EQ",
          value: type === "shortlisted" ? 1 : type === "pipelined" ? 2 : 3,
        };
      }
      const res = await fetchAllSubmissions({
        coll: "Submission",
        pg: pg,
        lim: lim,
        ref: "JobPosting Candidate",
        // fil: { uiid: { type: "IN", value: job.submissions || [] },"statusHistory.status": {  type: "ARRAY_LAST_TWO_FIELDS_EQ", value: 1 }  },
        // fil: {
        //   uiid: { type: "IN", value: submissionIds || [] },
        //   "statusHistory.status": {
        //     type: "ARRAY_LAST_TWO_FIELDS_EQ",
        //     value: type === "shortlisted" ? 1 : type === "pipelined" ? 2 : 3,
        //   },
        // },
        fil: fil,
        // ret: `uiid submissionStatus addedBy addedOn
        //       candidateId.firstName candidateId.lastName candidateId.mobile
        //       candidateId.source candidateId.skills candidateId.noticePeriod
        //       jobPostId.jobInfo.payments jobPostId.jobInfo.location`,
        ret: "uiid candidateId jobPostId addedBy addedOn statusHistory",
        extret: "uiid firstName",
        incl: [
          "jobInfo.workAuth jobInfo.location jobInfo.payments.billRate jobInfo.payments.payRate",
          "uiid firstName lastName mobile source resumes currentEmp noticePeriod salaryInfo.payRat exp location workAuth",
        ],
      });
      if (res?.data) {
        const rows = mapSubmissionsToRows(res?.data?.data || []);
        setAccordionData((prev) => ({ ...prev, [job?.uiid]: rows }));
      }
    } catch (err) {
      console.error("Error fetching submissions:", err);
    } finally {
      setAccordionLoading((prev) => ({ ...prev, [job?.uiid]: false }));
    }
  };
  const handleFetchTalentMatch = async (job, pg = 1, lim = 10) => {
    try {
      setAccordionLoading((prev) => ({ ...prev, [job?.uiid]: true }));
      const res = await fetchTalentMatch({
        coll: "TalentMatche",
        pg: pg,
        lim: lim,
        ref: "JobPosting Candidate",
        fil: { uiid: { type: "IN", value: job.talentMatchIds || [] } },
        ret: "uiid candidateId jobPostId addedBy addedOn statusHistory",
        extret: "uiid firstName",
        incl: [
          "jobInfo.workAuth jobInfo.location jobInfo.payments.billRate jobInfo.payments.payRate",
          "uiid firstName lastName mobile source resumes currentEmp noticePeriod salaryInfo.payRate workAuth exp location",
        ],
      });

      if (res?.data?.data) {
        const structuredRows = mapSubmissionsToRows(res?.data?.data);
        setAccordionData((prev) => ({
          ...prev,
          [job.uiid]: structuredRows,
        }));
      } else {
        showToast("No talent match data found", "info");
        setAccordionData((prev) => ({ ...prev, [job?.uiid]: [] }));
      }
    } catch (err) {
      console.error("❌ Error fetching talent match:", err);
      showToast("Failed to fetch talent match", "error");
    } finally {
      setAccordionLoading((prev) => ({ ...prev, [job?.uiid]: false }));
    }
  };

  const applyStatusChange = async (row, newStatus, scheduledDate = null) => {
    const payload = [
      {
        type: "PUSH",
        value: {
          statusHistory: {
            addedBy: user?.data?.uiid,
            addedOn: new Date().toISOString(),
            status: newStatus,
            ...(scheduledDate && {
              scheduledDate: new Date(scheduledDate).toISOString(),
            }),
          },
        },
      },
    ];

    const res = await updateJobPostStatus({
      coll: "JobPosting",
      uiid: row?.uiid,
      payload,
    });

    if (res?.data) {
      const updatedJobs = [...jobs];
      const index = updatedJobs.findIndex((job) => job.uiid === row?.uiid);
      if (index !== -1) {
        updatedJobs[index] = {
          ...updatedJobs[index],
          statusHistory: [
            ...(updatedJobs[index].statusHistory || []),
            {
              addedBy: user?.data?.uiid,
              addedOn: new Date().toISOString(),
              status: newStatus,
              ...(scheduledDate && {
                scheduledDate: new Date(scheduledDate).toISOString(),
              }),
            },
          ],
        };
      }
      dispatch(updateBdmJobs(updatedJobs));
      showToast("Status updated successfully", "success");
    } else {
      showToast("Failed to update status", "error");
    }
  };

  const handleStatusChange = async (option, row) => {
    try {
      const newStatus = option;
      const currentStatus =
        row?.statusHistory && row?.statusHistory?.length > 0
          ? row?.statusHistory[row?.statusHistory?.length - 1]?.status
          : 2;
      if (currentStatus === newStatus) {
        showToast("Status already set to this value", "info");
        return;
      }

      // Open lead capture modal for relevant statuses
      if (LEAD_CAPTURE_STATUSES.includes(newStatus)) {
        setLeadCaptureRow(row);
        setLeadCaptureStatus(newStatus);
        setLeadCompanyName(row?.companyName !== "N/A" ? row?.companyName : "");
        setLeadLinkedInUrl("");
        setLeadUrlError("");

        if (user?.data?.role?.type === 3) {
          const fullName =
            `${user?.data?.firstName || ""} ${user?.data?.lastName || ""}`.trim();
          setLeadAssignedTo({
            label: fullName,
            value: `${user?.data?.uiid}`,
          });
        } else {
          setLeadAssignedTo("");
        }

        setLeadCaptureModal(true);
        return;
      }

      await applyStatusChange(row, newStatus);
    } catch (err) {
      console.error(err);
      showToast("Failed to update status", "error");
    }
  };

  const resetLeadModal = () => {
    setLeadCaptureModal(false);
    setLeadCaptureRow(null);
    setLeadCaptureStatus(null);
    setLeadCompanyName("");
    setLeadLinkedInUrl("");
    setLeadUrlError("");
    setCompanyAlreadyExists(false);
    setExistingCompanyUiid(null);
    setCheckingCompany(false);
    setInterviewDate(null);
    setInterviewDateError("");
    setExistingLeadJobUiid(null);
    setLeadAssignedTo("");
  };

  const handleLeadCaptureSubmit = async () => {
    if (!leadCompanyName.trim()) {
      showToast("Company name is required.", "error", 3000);
      return;
    }

    // Validate LinkedIn URL only if company is new
    if (!companyAlreadyExists) {
      const urlError = validateLinkedInCompanyUrl(leadLinkedInUrl);
      if (urlError) {
        setLeadUrlError(urlError);
        showToast(urlError, "error", 4000);
        return;
      }
    }

    // Validate interview date if applicable
    const isInterviewStatus = [5, 6, 7].includes(leadCaptureStatus);
    if (isInterviewStatus) {
      const dateError = validateInterviewDate(
        interviewDate,
        leadCaptureStatus,
        leadCaptureRow?.statusHistory,
      );
      if (dateError) {
        setInterviewDateError(dateError);
        showToast(dateError, "error", 4000);
        return;
      }
    }

    try {
      setLeadSubmitting(true);

      let companyUiid = existingCompanyUiid;

      // create and update logic - company
      if (!companyAlreadyExists) {
        const companyRes = await addLeadCompany({
          coll: "LeadCompany",
          payload: {
            name: leadCompanyName.trim(),
            linkedInUrl: leadLinkedInUrl.trim(),
            addedBy: user?.data?.uiid,
            status: 1,
            assignedTo: leadAssignedTo?.value
              ? Number(leadAssignedTo.value)
              : undefined,
          },
        });

        if (!companyRes?.data) {
          showToast(
            "Failed to create lead company. Please try again.",
            "error",
          );
          return;
        }

        companyUiid = companyRes?.data?.data?.uiid;
        showToast("Company added successfully.", "success");
      } else {
        if (leadAssignedTo?.value) {
          await updateLeadCompany({
            coll: "LeadCompany",
            uiid: existingCompanyUiid,
            payload: [
              {
                type: "SET",
                value: {
                  assignedTo: Number(leadAssignedTo.value),
                },
              },
            ],
          });
        }
      }

      // create and update logic - job
      const lastStatus =
        leadCaptureRow?.statusHistory?.length > 0
          ? leadCaptureRow.statusHistory[
              leadCaptureRow.statusHistory.length - 1
            ]?.status
          : 2;

      const currentOption =
        statusOptions.find((opt) => opt.value === lastStatus) ||
        statusOptions.find((opt) => opt.value === 2);

      const scheduledDateISO =
        isInterviewStatus && interviewDate
          ? new Date(interviewDate).toISOString()
          : undefined;

      if (existingLeadJobUiid) {
        // Update existing LeadJob
        const jobUpdateRes = await updateLeadJob({
          coll: "LeadJob",
          uiid: existingLeadJobUiid,
          payload: [
            {
              type: "SET",
              value: {
                status: leadCaptureStatus,
                ...(scheduledDateISO && { scheduledDate: scheduledDateISO }),
              },
            },
          ],
        });

        if (!jobUpdateRes?.data) {
          showToast("Failed to update lead job. Please try again.", "error");
        } else {
          showToast("Lead job updated successfully!", "success");
        }
      } else {
        // Create new LeadJob
        const jobCreateRes = await addLeadJob({
          coll: "LeadJob",
          payload: {
            jobTitle: leadCaptureRow?.jobTitle || "",
            companyId: companyUiid,
            addedBy: user?.data?.uiid,
            status: currentOption?.value,
            jobUrl: leadCaptureRow?.jobUrl || "",
            location: { city: "", state: "", country: "" },
            postedOn: leadCaptureRow?.jobCreatedOn,
            ...(scheduledDateISO && { scheduledDate: scheduledDateISO }),
          },
        });

        if (!jobCreateRes?.data) {
          showToast(
            "Lead job creation failed. Please add manually in Leads.",
            "error",
          );
        } else {
          showToast("Lead job added successfully!", "success");
        }
      }

      // Apply the status change
      await applyStatusChange(
        leadCaptureRow,
        leadCaptureStatus,
        isInterviewStatus ? interviewDate : null,
      );

      resetLeadModal();
    } catch (err) {
      console.error("Lead capture error:", err);
      showToast(
        "An unexpected error occurred. Please try again.",
        "error",
        3000,
      );
    } finally {
      setLeadSubmitting(false);
    }
  };

  const extractUiid = (str) => {
    if (!str || typeof str !== "string") return null;

    const parts = str.split("-");
    const last = parts[parts.length - 1];

    const num = Number(last);
    return isNaN(num) ? null : num;
  };

  const handleRecruiterChange = async (newRecruiter, row, isConfirmed = false) => {
    setLoading(true);
    try {
      const normalizedRecruiters = (newRecruiter || []).map((r) => {
        if (typeof r === "object" && r.value) {
          return r;
        } else {
          const found = allRecruiters.find((opt) => opt.value === r);
          return found || { label: String(r), value: r };
        }
      });

      const uiidList = normalizedRecruiters
        .map((r) => extractUiid(r.value))
        .filter((id) => id !== null);

      const allMap = {};
      allRecruiters.forEach(opt => {
        const id = extractUiid(opt.value);
        if (id) allMap[id] = opt;
      });

      const totalBots = uiidList.filter(id => allMap[id] && allMap[id].userType == 2);

      if (totalBots.length > 1) {
        showToast("A job can be assigned to only one bot user.", "error",5000);
        setRecruiter((prev) => ({ ...prev }));
        return;
      }

      const previousUiids = (recruiter[row.uiid] || []).map(r => Number(r.uiid));

      const deselectedUiids = previousUiids.filter((id) => !uiidList.includes(id));
      const deselectedBots = deselectedUiids.filter(
        (id) => allMap[id] && allMap[id].userType == 2
      );

      if (deselectedBots.length > 0) {
        if (row?.aiRecruiter?.status !== 1) {
          showToast(`Cannot remove bot while the job is in progress.`, "error",5000);
          setRecruiter((prev) => ({ ...prev }));
          setLoading(false);
          return;
        }
      }

      const freshlyAddedBots = (normalizedRecruiters || []).filter(r => {
        const id = extractUiid(r.value);
        if (previousUiids.includes(id)) return false;
        return r.userType == 2 || (allMap[id] && allMap[id].userType == 2);
      });

      if (freshlyAddedBots.length === 1 && !isConfirmed) {
        setRecruiter((prev) => ({ ...prev }));
        const botUiid = extractUiid(freshlyAddedBots[0].value);
        if (!botUiid) return;

        let availableCredits = 0;
        try {
          const integrationResponse = await getAllIntegrations({
            coll: "Integration",
            fil: JSON.stringify({ category: { type: "NONE", value: 6 }, type: { type: "NONE", value: 2 } }),
            ret: "uiid"
          });
          const integrationIds = integrationResponse?.data?.data?.map(i => i.uiid) || [];

          if (integrationIds.length > 0) {
            const accessRes = await getAllIntegrationAccess({
              coll: "IntegrationAccess",
              fil: {
                integrationId: { type: "IN", value: integrationIds },
                userId: { type: "NONE", value: botUiid }
              }
            });
            const accessList = accessRes?.data?.data || [];
            availableCredits = accessList.reduce((sum, access) => sum + Number(access?.accessConfig?.credits || 0), 0);
          }
        } catch (e) {
          console.error("Failed to fetch bot credits", e);
          showToast("Failed to fetch bot credits", "error");
          return;
        }

        const orgSettings = raSettings?.[0]?.aiCallSettings || {};
        const maxCallsPerJob = Number(orgSettings.maxCallsPerJob || 0);

        if (availableCredits === 0) {
          showToast("Cannot assign bot: Zero credits available for this bot recruiter.", "error",5000);
          return;
        }

        if (availableCredits < maxCallsPerJob) {
          showToast(`Cannot assign bot: Available credits (${availableCredits}) are less than required max calls per job (${maxCallsPerJob}).`, "error",5000);
          return;
        }

        setPendingBotAssignment({ newRecruiter, row });
        setBotConfirmModal(true);
        return;
      }

      const isAiRecruiter = totalBots.length > 0;
      let setValue;
      if(isAiRecruiter){
        setValue = {
          // notifyTo: normalizedRecruiters.map((r) => r.value),
          notifyTo: uiidList,
          aiRecruiter: {
            isAiRecruiter: true,
            status: 1,
            maximumCalls: Number(maximumCalls),
          },
          _skipFlatten: ["notifyTo"]
        }
      }
      else {
        setValue = {
          notifyTo: uiidList,
          aiRecruiter: {
            isAiRecruiter: false,
            status: 1
          },
          _skipFlatten: ["notifyTo"]
        };
      }
      const payload = [
        {
          type: "SET",
          value: setValue,
        },
      ];
      // console.log("normalizedRecruiters",normalizedRecruiters)
      const res = await updateJobPostStatus({
        coll: "JobPosting",
        uiid: row.uiid,
        payload,
      });
      if (res?.data) {
        showToast("Recruiter updated successfully", "success");
        window.dispatchEvent(new CustomEvent('recheckAiJobs'));
        setRecruiter((prev) => ({
          ...prev,
          [row.uiid]: normalizedRecruiters.map((r) => {
            const uiid = extractUiid(r.value);
            const parts = r.label ? r.label.split(" ") : [];
            return {
              firstName: parts[0] || "",
              lastName: parts.slice(1).join(" ") || "",
              uiid: uiid
            };
          }),
        }));

        // setRecruiter((prev) => ({
        //   ...prev,
        //   [row.uiid]: normalizedRecruiters.map((r) => ({
        //     firstName: r.label,
        //     uiid: r.value,
        //   })),
        // }));
        // setAllRecruiters((prev) => ({
        //   ...prev,
        //   [row.uiid]: normalizedRecruiters.map((r) => ({
        //     firstName: r.label,
        //     uiid: r.value,
        //   })),
        // }));
        //   setRecruiter((prev) => ({
        //   ...prev,
        //   [row.uiid]: normalizedRecruiters.map((r) => {
        //     const uiid = extractUiid(r.value);
        //     const [firstName, lastName] = r.label.split(" ");

        //     return {
        //       firstName: firstName,
        //       lastName: lastName || "",
        //       uiid: uiid
        //     };
        //   }),
        // }));
      } else {
        showToast("Failed to update recruiter", "error");
      }
    } catch (err) {
      console.error("Error updating recruiter:", err);
      showToast("Error updating recruiter", "error");
    }
    finally {
      setLoading(false);
      setMaximumCalls(null);
    }
  };

  const mapSubmissionsToRows = (submissions = []) => {
    return submissions.map((submission) => {
      const candidate = submission?.candidateId || {};
      const job = submission?.jobPostId || {};
      const jobInfo = job?.jobInfo || {};
      const Currency = {
        1: "USD",
        2: "INR",
        3: "CAD",
      };
      //console.log("submission",submission)
      return {
        submissionId: submission?.uiid ?? "N/A",
        applicantName:
          `${candidate?.firstName || ""} ${candidate?.lastName || ""}`.trim() ||
          "N/A",
        workAuth: candidate?.workAuth ? candidate?.workAuth : "N/A",
        mobile: candidate?.mobile?.primary?.number
          ? `${candidate?.mobile?.primary?.code} ${candidate?.mobile?.primary?.number}`
          : "N/A",
        applicantLocation: candidate?.location
          ? [
            candidate?.location?.city,
            candidate?.location?.state,
          ]
            .filter(Boolean)
            .join(", ") : "N/A",
        country: candidate?.location?.country || "N/A",
        experience: candidate?.exp
          ? `${candidate?.exp?.year || 0}y ${candidate?.exp?.mon || 0}m`
          : "N/A",
        source: candidate?.source || "N/A",
        resume: candidate?.resumes?.length
          ? `Resume (${candidate?.resumes?.length})`
          : "N/A",
        revisionStatus: "Active",
        // applicationStatus: "In Progress", // no status field in submission itself
        applicationStatus: submission?.statusHistory || [], // no status field in submission itself

        // billRate: jobInfo.payments?.billRate?.amount
        //   ? `${jobInfo.payments.billRate.amount}`
        //   : "N/A",
        // payRate: jobInfo.payments?.payRate?.amount
        //   ? `${jobInfo.payments.payRate.amount.min}-${jobInfo.payments.payRate.amount.max}`
        //   : "N/A",
        billRate: jobInfo?.payments?.billRate?.currency
          ? `${Currency[jobInfo?.payments?.billRate?.currency] || "N/A"}-${
              jobInfo?.payments?.billRate?.amount || "0"
            }/${jobInfo?.payments?.billRate?.freqType || ""}/${
              jobInfo?.payments?.billRate?.employmentType || ""
            }`
          : "N/A",

        payRate: jobInfo?.payments?.payRate?.currency
          ? `${Currency[jobInfo?.payments?.payRate?.currency] || "N/A"}/${
              jobInfo?.payments?.payRate?.amount?.min || "0"
            }-${jobInfo?.payments?.payRate?.amount?.max || "0"}/${
              jobInfo?.payments?.payRate?.freqType || ""
            }/${jobInfo?.payments?.payRate?.employmentType || ""}`
          : "N/A",

        employerName: candidate?.currentEmp ? "Yes" : "N/A",
        availability: candidate?.noticePeriod?.days === 0 ? "Yes" : "No",
        submittedBy: formatWords2(submission?.addedBy?.firstName || "N/A"),
        pwSubmissionType: submission?.type || "N/A",
        noticePeriod: candidate?.noticePeriod
          ? `${candidate?.noticePeriod?.days} days`
          : "N/A",
        // currentCTC: candidate.salaryInfo?.payRate || "N/A",
        currentCTC: candidate?.salaryInfo?.payRate
          ? (() => {
              const { currency, amount, freqType, employmentType } =
                candidate?.salaryInfo?.payRate;
              const curr = Currency[currency] || "N/A";
              const amt = amount ?? 0;
              const freq =
                freqType?.charAt(0).toUpperCase() + freqType?.slice(1) || "";
              const emp = employmentTypeMap[employmentType] || "";

              let display = `${curr} ${amt}`;
              if (freq) display += ` / ${freq}`;
              if (emp) display += ` / ${emp}`;
              return display.trim();
            })()
          : "N/A",
        submittedOn: submission?.addedOn
          ? formatDateTime(convertFromUTC(submission?.addedOn))
          : "N/A",
        uiid: submission?.uiid || null,
        candidateId: candidate?.uiid || null,
        notes: submission?.notes ?? [],
      };
    });
  };
  const fetchRecruiters = async () => {
    // dispatch(
    //   totalCountStart({
    //     collection: "users",
    //     coll: "User",
    //     tname: "recruiterCount",
    //     app : "master",
    // filters : {"role":{"type": "IN", "value":[4]},"organizationId":{"type": "NONE", "value": orgId}},
    //   })
    // );
    // const count = await getTotalCountApi({
    //   collection: "users",
    //   coll: "User",
    //   filters: {
    //     role: { type: "IN", value: [1, 3, 4] },
    //     organizationId: { type: "NONE", value: orgId },
    //   },
    //   app: "master",
    // });
    const count = await userRefCount({
      fil: JSON.stringify({
        "role.type": { type: "IN", value: [1, 3, 4] },
        status: { type: "NONE", value: 1 },
      }),
    });
    const recruiterCount = count?.data?.data || 0;
    try {
      const res = await fetchAllRecruitersAndBDMUsers({
        orgId,
        lim: recruiterCount,
        ret: "uiid firstName lastName userType botAssignedTo",
      });
      if (res?.data?.data) {
        const loggedInUiid = user?.data?.uiid;
        const isAdmin = user?.data?.role?.type === 1;
        // const recruiterList = res.data.data.map((r) => ({
        //   label: `${r?.firstName} ${r?.lastName || ""}`.trim(),
        //   // value: r.uiid,
        //   value: `${r.firstName} ${r.lastName}-${r.uiid}`,
        // }));
        let filteredRecruiters = res.data.data;
        if (!isAdmin) {
          filteredRecruiters = res.data.data.filter((r) => {
            if (r.userType !== 2) return true;
            const assignedTo = r.botAssignedTo || [];
            const assignedUiids = assignedTo.map(bot => {
              if (typeof bot === "object" && bot !== null) {
                return String(bot.uiid || bot.value);
              }
              return String(bot);
            });
            return assignedUiids.includes(String(loggedInUiid));
          });
        }

        const recruiterList = filteredRecruiters.map((r) => {
          const first = r.firstName || "";
          const last = r.lastName || "";
          const fullName = `${first} ${last}`.trim(); // Removes undefined
          const userType = r.userType || 1

          return {
            label: fullName,
            value: `${fullName}-${r.uiid}`, // Consistent format
            userType
          };
        });

        setAllRecruiters(recruiterList);
      }
    } catch (error) {
      console.error("Failed to fetch recruiters", error);
    }
  };

  const fetchBdmSettings = async () => {
    const params = {
      coll: "Setting",
      ret: "bdmSettings uiid",
    };
    const response = await getBdmSettingsApi(params);
    if (response.success) {
      dispatch(setBdmSettings(response?.data?.data));
    } else {
      console.warn(response?.error || "Failed to fetch bdmSettings");
    }
  };

  const fetchExpiringJobs = async () => {
    if (
      bdmSettings?.jobInactivityLimitDays &&
      bdmSettings.jobInactivityLimitDays > 0
    ) {
      const params = {
        coll: "JobPosting",
        fil: JSON.stringify({
          jobInactivityLimitDays: {
            type: "JOBS_NO_ACTIVITY",
            value: bdmSettings.jobInactivityLimitDays,
          },
        }),
        useAggregate: true,
        ret: "job.uiid job.title job.description jobInfo.jobCode currentStatus addedOn company.uiid company.name",
      };
      const response = await fetchNoActivityJobs(params);

      if (response?.success) {
        setexpiringJobs(response.data?.data?.[0]);
        if (response.data?.data?.[0]?.totalCount > 0) {
          setIsExpiringJobsModel(true);
        }
      } else {
        // showToast("Unable to fetch expiring jobs", "error");  //020526 mahee commented the toast because it was showing multiple times when the user was on the page and the data was being fetched every 5 mins. We can re-enable it if needed in future.
      }
    }
  };

  const convertConditions = (conditions = []) => {
    return conditions.map((cond) => {
      const apiField = COLUMN_MAP[cond.filterColunm] || cond.filterColunm;

      return {
        [apiField]: {
          type: OPERATOR_MAP[cond.operator],
          value: cond.filterValue?.trim(),
        },
      };
    });
  };

  const buildFilParams = (config) => {
    const allFilters = convertConditions(config.allFilterConditions); // array
    const anyFilters = convertConditions(config.anyFilterConditions); // array

    let mergedFilters = [];

    // if (allFilters.length > 0) {
    mergedFilters.push(allFilters); // push whole array (group 1)
    // }

    // if (anyFilters.length > 0) {
    mergedFilters.push(anyFilters); // push whole array (group 2)
    // }

    if (mergedFilters.length === 0) {
      return {};
    }

    return {
      uiid: {
        type: "TABLE_FILTER",
        value: mergedFilters,
      },
    };
  };

  const mapFilteredApiResponse = (jobs) => {
    return jobs.map((job, index) => {
      const companyName = job.companyId?.[0]?.name || "N/A";
      const title = job.jobId?.[0]?.title || "N/A";
      const submissionCounts = getSubmissionCounts(job?.submissions || []);
      return {
        id: index,
        uiid: job?.uiid,
        icons: "",
        code: job?.jobInfo?.jobCode || "",
        jobTitle: title,
        companyName: companyName,
        jobLocation: job?.jobInfo?.location
          ? [
              job?.jobInfo?.location?.city,
              job?.jobInfo?.location?.state,
              job?.jobInfo?.location?.country,
            ]
              .filter(Boolean)
              .join(", ")
          : "N/A",
        jobStatus: job?.statusHistory?.[0]?.status || "-",
        contact: Math.floor(Math.random() * 6),
        online: onlineStatus[Math.floor(Math.random() * 2)],
        applications: job?.talentMatch?.ids?.length || 0,

        shortlisted: submissionCounts?.shortlisted,
        pipelined: submissionCounts?.pipeline,
        // submitted: submissionCounts?.submission,
        submitted: job?.submissions?.length,
        submissions: job?.submissions || [],
        clientBill: formatPayment(job.jobInfo?.payments?.billRate),

        payBill: formatPayment(job.jobInfo?.payments?.payRate),
        deliveryManager: job?.assignedTo?.[0]?.firstName || "-",
        jobCreatedBy: job?.addedBy?.[0]?.firstName,
        // deliveryManager: "-", // not in API
        // jobCreatedBy: job.addedBy || "", // not in API
        jobCreatedOn: job?.addedOn
          ? formatDateTime(convertFromUTC(job?.addedOn))
          : "",

        notes: job?.notes || [],
        statusHistory: job?.statusHistory || [],

        // recruiter: "-", // not in API
        recruiter: job?.notifyTo || "-",
        talentMatchIds: job?.talentMatch?.ids || [],
        minSalary: job?.jobInfo?.payments?.payRate?.amount?.min || 0,
        maxSalary: job?.jobInfo?.payments?.payRate?.amount?.max || 0,
      };
    });
  };

  const handleFilterChange = React.useCallback((filterConfig) => {
    setActiveFilters(filterConfig); // <-- Only update state
  }, []);

  const getFilterData = (fil) => {
    const params = {
      coll: "JobPosting",
      lim: limit,
      pg: page,
      useAggregate: true,
      // ret: "uiid jobInfo jobId addedOn addedBy statusHistory notes submissions notifyTo assignedTo talentMatch",
      fil: JSON.stringify(fil),
    };

    jobsTableFilter(params)
      .then((res) => {
        const transformed = mapFilteredApiResponse(
          res?.data?.data[0]?.rows || [],
        );
        setFilteredJobs(transformed);
        setTotalCount(res?.data?.data[0]?.totalCount[0]?.count);
      })
      .catch(console.error);
  };

  // useEffect(() => {
  //   if (!activeFilters) return;

  //   if (activeFilters?.allFilterConditions?.length > 0 || activeFilters?.anyFilterConditions?.length > 0) {
  //     const fil = buildFilParams(activeFilters);
  //     getFilterData(fil);
  //   } else {
  //     setFilteredJobs();
  //     setTotalCount(value?.allJobsPosts?.data || 0);
  //   }
  // }, [activeFilters]);

  const fetchAllJobs = () => {
    dispatch(
      totalCountStart({
        collection: "jobpostings",
        coll: "JobPosting",
        tname: "allJobsPosts",
        app: "ats",
        filters: { "statusHistory.status": { type: "EXCLUDE", value: 1 } },
      }),
    );
    dispatch(
      fetchAllJobsStart({
        coll: "JobPosting",
        lim: limit,
        pg: page,
        // ret: "uiid jobInfo jobId addedOn addedBy statusHistory",
        ret: "uiid jobInfo jobId addedOn addedBy statusHistory notes submissions notifyTo assignedTo talentMatch aiRecruiter",
        // ref: "Job Note Submission",
        // ref: "Job",
        ref: "Job Submission",
        fil: { "statusHistory.status": { type: "EXCLUDE", value: 1 } },
        extret: "uiid firstName lastName",
        incl: ["", "uiid statusHistory.status currentStatus"],
        sort: { addedOn: -1 },
      }),
    );
  };

  const fetchJobsSearch = () => {
    dispatch(
      totalCountStart({
        collection: "jobpostings",
        coll: "JobPosting",
        tname: "allJobsPosts",
        app: "ats",
        useAggregate: true,
        filters: {
          "statusHistory.status": { type: "EXCLUDE", value: 1 },
          uiid: { type: "AG_JOB_POSTINGS", value: searchValue.trim() },
        },
        errorHandler: true,
      }),
    );
    dispatch(
      fetchAllJobsStart({
        coll: "JobPosting",
        lim: limit,
        pg: page,
        ret: "uiid jobInfo jobId addedOn addedBy statusHistory notes submissions notifyTo assignedTo talentMatch",
        ref: "Job Submission",
        useAggregate: true,
        fil: {
          "statusHistory.status": { type: "EXCLUDE", value: 1 },
          uiid: { type: "AG_JOB_POSTINGS", value: searchValue.trim() },
        },
        extret: "uiid firstName lastName",
        incl: ["", "uiid statusHistory.status currentStatus"],
        sort: { addedOn: -1 },
      }),
    );
  };

  useEffect(() => {
    // if (activeFilters?.allFilterConditions?.length > 0 || activeFilters?.anyFilterConditions?.length > 0) {
    //   const fil = buildFilParams(activeFilters);
    //   getFilterData(fil);
    // } else {
    if (searchValue.trim().length > 1) {
      fetchJobsSearch();
    } else {
      fetchAllJobs();
    }
    setTotalCount(value?.allJobsPosts?.data || 0);
    //setPage(1);
    setExpandedRows({});
    // }
  }, [dispatch, page, limit]);

  useEffect(() => {
    fetchRecruiters();
    fetchBdmSettings();
    const today = new Date().toISOString().split("T")[0]; // format: 'YYYY-MM-DD'
    const displayedDate = expiringJobsDisplayedOn
      ? new Date(expiringJobsDisplayedOn).toISOString().split("T")[0]
      : null;

    if (!displayedDate || displayedDate !== today) {
      fetchExpiringJobs();
    }
  }, []);

  useState(() => {
    if (
      !activeFilters?.allFilterConditions?.length > 0 &&
      !activeFilters?.anyFilterConditions?.length > 0
    ) {
      setTotalCount(value?.allJobsPosts?.data || 0);
    }
  }, [value]);

  useEffect(() => {
    if (value?.allJobsPosts?.data !== undefined) {
      setTotalCount(value.allJobsPosts.data);
    }
  }, [value]);

  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    if (searchValue.trim().length <= 1) {
      return;
    }
    debounceRef.current = setTimeout(() => {
      fetchJobsSearch();
    }, 500);

    //setTotalCount(value?.allJobsPosts?.data || 0)

    setPage(1);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [searchValue]);

  if (loading) {
    return (
      <div className="absolute inset-0 flex items-center justify-center bg-white/40 backdrop-blur-sm z-50 rounded-lg">
        <LogoLoader />
      </div>
    );
  }

  const handleSubmissionStatusUpdate = async ({
    submissionId,
    candidateId,
    newStatus,
    isTalentMatch,
    type,
  }) => {
    // Update the local accordion data to reflect the change
    setAccordionData((prev) => {
      const updatedData = { ...prev };

      // Find and update the specific row in the accordion data
      Object.keys(updatedData).forEach((jobUiid) => {
        updatedData[jobUiid] = updatedData[jobUiid].map((row) => {
          if (row.submissionId === submissionId) {
            return {
              ...row,
              applicationStatus: [
                ...(row.applicationStatus || []),
                {
                  status: newStatus,
                  addedBy: { uiid: user?.data?.uiid },
                  addedOn: new Date().toISOString(),
                },
              ],
            };
          }
          return row;
        });
      });

      return updatedData;
    });

    // Optionally refetch the jobs data to get updated counts
    // This will refresh the shortlisted/pipelined/submitted counts in the parent table
    // dispatch(
    //   fetchAllJobsStart({
    //     coll: "JobPosting",
    //     lim: limit,
    //     pg: page,
    //     ret: "uiid jobInfo jobId addedOn addedBy statusHistory notes submissions notifyTo assignedTo talentMatch",
    //     ref: "Job Submission",
    //     fil: { "statusHistory.status": { type: "EXCLUDE", value: 1 } },
    //     extret: "uiid firstName lastName",
    //     incl: ["", "uiid statusHistory.status currentStatus"],
    //     sort: { addedOn: -1 },
    //   })
    // );
  };

  return (
    <div className="flex flex-col mt-5 overflow-auto">
      <div className="flex flex-grow overflow-auto gap-4 mx-0.5">
        <TableAdv
          showCheckbox
          // singleSelection
          columns={colJobDetails}
          rows={mappedRowsJobDetails}
          defaultSelectedRows={showDataId}
          serverPagination={true}
          totalCount={totalCount}
          page={page}
          expandedRows={expandedRows}
          limit={limit}
          tableId={"BDMAllJobsTable"}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          info={"info"}
          serverFiltering={true}
          onFilterChange={handleFilterChange}
          serverOnSearch={(key, value) => {
            setSearchValue(value);
            if (!value) {
              fetchAllJobs();
            }
          }}
          accordion={(row, accordionType) => {
            const submissionRows = accordionData[row?.uiid] || [];
            
            let accTotalCount = 0;
            if (accordionType === "applications") accTotalCount = row?.applications || 0;
            else if (accordionType === "shortlisted") accTotalCount = row?.shortlisted || 0;
            else if (accordionType === "pipelined") accTotalCount = row?.pipelined || 0;
            else if (accordionType === "submitted") accTotalCount = row?.submitted || 0;

            const handleAccordionFetch = (pg, lim) => {
              if (accordionType === "applications") {
                handleFetchTalentMatch(row, pg, lim);
              } else {
                handleFetchSubmissions(row, accordionType, pg, lim);
              }
            };

            return (
              <JobsAccordion
                rowData={submissionRows}
                type={accordionType}
                loading={accordionLoading?.[row?.uiid]}
                onStatusUpdate={handleSubmissionStatusUpdate}
                totalCount={accTotalCount}
                onFetchData={handleAccordionFetch}
              />
            );
          }}
          onSelectionChange={handleSelectionChange}
          toolbarRight={{
            search: true,
            fullScreen: true,
            filter: true,
            add: selectedRows.length > 0 && [
              {
                component: (
                  <Button
                    title="Add Note"
                    icon="add"
                    size="sm"
                    onClick={() => {
                      setShowDataId([...selectedRows]);
                      setIsNotePanelOpen(true);
                    }}
                  />
                ),
              },
            ],
          }}
        />

        {/* Notes sidebar stays unchanged */}
        {isNotePanelOpen ? (
          <div className="w-md shadow p-4 overflow-auto flex flex-col gap-5">
            <div className="p-2">
              <div className="flex justify-between items-center mb-3">
                <h5 className="font-semibold">Add Notes</h5>
                <Button
                  type="icon"
                  icon={"close"}
                  onClick={() => {
                    setIsNotePanelOpen(false);
                    setShowDataId([]);
                  }}
                  size="xs"
                />
              </div>
              {/* <FormFieldSet type="textArea" rows={5} placeholder="" /> */}
              <FormFieldSet
                type="textArea"
                rows={5}
                noTitle
                placeholder=""
                value={note}
                onChange={(value) => setNote(value)}
              />
            </div>
            <div className="p-2">
              <h6 className="font-semibold mb-2">Selected Jobs</h6>
              {selectedRows.length !== 0 ? (
                rowData.map((row, index) => (
                  <div className="mb-2" key={index}>
                    <DetailCard
                      size="xs"
                      title={
                        <div className="flex items-center gap-4 p-2">
                          <span className="material-symbols-outlined text-primary">
                            business_center
                          </span>
                          <div className="font-bold">
                            <p className="my-1">
                              {formatWords2(row?.jobTitle)}
                            </p>
                            <p className="text-xs text-gray-400">{row?.code}</p>
                          </div>
                        </div>
                      }
                      headeRight={
                        <div>
                          <Button
                            icon={"delete"}
                            variant="text"
                            type="icon"
                            color="black"
                            onClick={() => handleDelete(row?.id)}
                          />
                        </div>
                      }
                    >
                      <AdvSeparator
                        gap="gap-6"
                        className="gap-y-6 overflow-hidden"
                      >
                        {["companyName", "payBill"].map((key, index) => (
                          <div className="p-3" key={index}>
                            <InfoTextAdv
                              title={
                                key === "companyName"
                                  ? "Company Name"
                                  : "Pay Rate"
                              }
                              titleProps={{ className: "!text-black" }}
                              value={
                                <div className="w-full ">
                                  <div className="text-black font-medium ">
                                    <h6 className="truncate whitespace-nowrap overflow-hidden">
                                      {truncateText(row[key])}
                                    </h6>
                                  </div>
                                </div>
                              }
                            />
                          </div>
                        ))}
                      </AdvSeparator>
                    </DetailCard>
                  </div>
                ))
              ) : (
                <p className="text-gray-600 font-md text-md">
                  No Selected Jobs
                </p>
              )}
            </div>
            <div className="mt-auto pt-4 flex justify-center">
              <Button onClick={handleNoteAdd} title="Apply" />
            </div>
          </div>
        ) : showSingleNotes && !isNotePanelOpen ? (
          <div className="w-md shadow p-2 overflow-auto flex flex-col gap-5">
            <div className="p-2">
              <div className="flex justify-between items-center mb-3">
                <h5 className="font-semibold">Add Notes</h5>
                <Button
                  type="icon"
                  icon={"close"}
                  onClick={() => {
                    setShowSingleNotes(false);
                    setSelectedRows((prev) =>
                      prev.filter((id) => !showDataId.includes(id)),
                    );
                    setShowDataId([]);
                    setNote("");
                  }}
                  size="xs"
                />
              </div>
              <FormFieldSet
                type="textArea"
                rows={5}
                placeholder=""
                value={note}
                onChange={(value) => setNote(value)}
              />
            </div>
            {/* <div className="p-2">
              <h6 className="font-semibold mb-2">Added Notes</h6>
              <div className="my-3">
                <DetailCard
                  size="xs"
                  title={
                    <div className="flex items-center gap-4 p-2">
                      <Avatar alt={"Ershad Mohammad"} showInitials noBorder />
                      <InfoTextAdv
                        title={"Ershad Mohammad"}
                        titleProps={{
                          className: "!text-black !text-sm  font-[600]",
                        }}
                        value={
                          <p className="line-clamp-1 text-gray font-[600] text-xs">
                            9 hours ago
                          </p>
                        }
                      />
                    </div>
                  }
                  headeRight={
                    <div>
                      <Button
                        icon={"more_vert"}
                        variant="text"
                        type="icon"
                        color="black"
                      />
                    </div>
                  }
                >
                  <p className="text-sm p-3 ">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  </p>
                </DetailCard>
              </div>
              <div className="my-3">
                <DetailCard
                  size="xs"
                  title={
                    <div className="flex items-center gap-4 p-2">
                      <Avatar alt={"Ramesh Manthri"} showInitials noBorder />
                      <InfoTextAdv
                        title={"Ramesh Manthri"}
                        titleProps={{
                          className: "!text-black !text-sm  font-[600]",
                        }}
                        value={
                          <p className="line-clamp-1 text-gray font-[600] text-xs">
                            6 hours ago
                          </p>
                        }
                      />
                    </div>
                  }
                  headeRight={
                    <div>
                      <Button
                        icon={"more_vert"}
                        variant="text"
                        type="icon"
                        color="black"
                      />
                    </div>
                  }
                >
                  <p className="text-sm p-3 ">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  </p>
                </DetailCard>
              </div>
            </div> */}
            <div className="p-2">
              <h6 className="font-semibold mb-2">Added Notes</h6>

              {/* {rowData[0]?.notes?.length > 0 ? (
                rowData[0].notes.map((note) => ( */}
              {notesLoading ? (
                <Skeleton variant="paragraph" lines={4} />
              ) : notes?.length > 0 ? (
                (notes || [])
                  .sort((a, b) => new Date(b?.addedOn) - new Date(a?.addedOn))
                  .map((note) => (
                    <div className="my-3" key={note?._id}>
                      <DetailCard
                        size="xs"
                        title={
                          <div className="flex items-center gap-4 p-2">
                            <Avatar
                              alt={`${formatWords2(note?.addedBy?.firstName) || ""}`}
                              showInitials
                              noBorder
                            />
                            <InfoTextAdv
                              title={`${formatWords2(note?.addedBy?.firstName) || ""}`}
                              titleProps={{
                                className: "!text-black !text-sm font-[600]",
                              }}
                              value={
                                <p className="line-clamp-1 text-gray font-[600] text-xs">
                                  {timeCalc(note?.addedOn)}
                                </p>
                              }
                            />
                          </div>
                        }
                        headeRight={
                          <div>
                            <Button
                              icon={"more_vert"}
                              variant="text"
                              type="icon"
                              color="black"
                            />
                          </div>
                        }
                      >
                        <p className="text-sm p-3">{note?.note || ""}</p>
                      </DetailCard>
                    </div>
                  ))
              ) : (
                <p className="text-gray-600 font-md text-md">No Notes Found</p>
              )}
            </div>

            <div className="mt-auto pt-4 flex justify-center">
              <Button onClick={handleNoteAdd} title="Apply" />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <Modal isOpen={isModalOpen} showCloseButton={false} width="max-w-6xl">
        <div>
          <Button
            color="black"
            icon={"arrow_left_alt"}
            variant="text"
            title={"Compose Mail"}
            className="!px-0 font-[500]"
            size="xl"
            onClick={() => setIsModalOpen(false)}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-5">
          <FormFieldSet
            type="select"
            title="Email Source"
            placeholder="Select"
            options={[
              { label: "Gmail", value: 1 },
              { label: "Outlook", value: 2 },
              { label: "Mailgun", value: 3 },
              { label: "AWS-SES", value: 4 },
            ]}
          // value={formData.emailSource}
          // onChange={(value) => handleChange("emailSource", value)}
          // error={errors.emailSource}
          />
          <FormFieldSet
            type="select"
            title="Email Account"
            placeholder="Select Account"
            options={[
              { label: "Brown", value: 1 },
              { label: "Aden", value: 2 },
            ]}
            // value={formData.emailAccount}
            // onChange={(value) => handleChange("emailAccount", value)}
            // error={errors.emailAccount}
          />
          <FormFieldSet
            type="datepicker"
            title="Date Picker"
            placeholder="Select Date"
            // value={formData.datePicker}
            // onChange={(value) => handleChange("datePicker", value)}
            // error={errors.datePicker}
          />
          <FormFieldSet
            type="select"
            title="Template"
            placeholder="Select"
            options={[
              { label: "Brown", value: 1 },
              { label: "Aden", value: 2 },
            ]}
            // value={formData.template}
            // onChange={(value) => handleChange("template", value)}
            // error={errors.template}
          />
          <FormFieldSet
            title="Subject"
            placeholder="Select"
            // value={formData.subject}
            // onChange={(value) => handleChange("subject", value)}
            // error={errors.subject}
          />
        </div>
        <div className="flex flex-col my-4 gap-4">
          <FormFieldSet
            value={["simon@tektreeinc.com", "john.doe@tektreeinc.com"]}
            maxCount={50}
            type="toMailIds"
            title="Include Test Emails Here: 2"
          />
          <FormFieldSet
            type="textArea"
            title="Text Here"
            rows={5}
            placeholder="Enter Text Here"
            // value={formData.emailText}
            // onChange={(value) => handleChange("emailText", value)}
            // error={errors.emailText}
          />
        </div>
        <div className="flex justify-end gap-5 my-10">
          <Button
            variant="outlined"
            title={"Cancel"}
            onClick={() => setIsModalOpen(false)}
          />
          <Button title={"Send Email"} />
        </div>
      </Modal>
      <Modal isOpen={scheduleModal} showCloseButton={false} width="max-w-7xl">
        <div className="p-2">
          <Button
            color="black"
            icon={"arrow_left_alt"}
            variant="text"
            title={"Schedule Interview"}
            className="!px-0 font-[500]"
            size="lg"
            onClick={() => setScheduleModal(false)}
          />
          <TableAdv
            rows={scheduleInterviewRows}
            columns={scheduleInterviewCols}
            showCheckbox
            tableId={"BDMAllJobsTable_scheduleinterview"}
            tdClassName="!py-3"
            onSelectionChange={setSelectedModalRows}
            defaultSelectedRows={selectedModalRows}
            toolbarRight={{
              search: true,
              fullScreen: true,
              add: [
                {
                  component: <Button title="Bulk Email" icon="add" size="sm" />,
                },
              ],
            }}
          />
          <div className="flex justify-end my-5">
            <Button
              title={"Cancel"}
              onClick={() => setScheduleModal(false)}
              variant="outlined"
            />
          </div>
        </div>
      </Modal>
      {/* <EditModal isOpen={editModal} onClose={() => setEditModal(false )} /> */}
      {/* Edit Job Modal */}
      <Modal
        isOpen={editModal}
        onClose={() => setEditModal(false)}
        title={"Edit"}
        titleColor={"primary"}
        // width="max-w-4xl"
        width="w-full"
      >
        {/* <EditModal onCancel={() => setOpenEditModal(false)} /> */}
        <AddJobPost
          onCancel={() => setEditModal(false)}
          jobpostId={selectedJobId}
          // onSuccess={() => {
          //   setEditModal(false);
          // }}
          onSuccess={() => {
            setEditModal(false);
            dispatch(
              fetchAllJobsStart({
                coll: "JobPosting",
                lim: limit,
                pg: page,
                // ret: "uiid jobInfo jobId addedOn addedBy statusHistory",
                ret: "uiid jobInfo jobId addedOn addedBy statusHistory notes submissions notifyTo assignedTo talentMatch",
                // ref: "Job Note Submission",
                // ref: "Job",
                ref: "Job Submission",
                fil: { "statusHistory.status": { type: "EXCLUDE", value: 1 } },
                extret: "uiid firstName",
                incl: ["", "uiid statusHistory.status"],
                sort: { addedOn: -1 },
              }),
            );
          }}
        />
      </Modal>
      <Backdrop isOpen={pageLoading}>
        <LogoLoader />
      </Backdrop>

      <Modal
        isOpen={isExpiringJobsModel}
        onClose={() => setIsExpiringJobsModel(false)}
        title={"Jobs Closing Today"}
        titleColor={"primary"}
        width="max-w-4xl"
        // width="w-full"
      >
        <ExpiringJobs
          days={bdmSettings?.jobInactivityLimitDays}
          onClose={() => setIsExpiringJobsModel(false)}
        />
      </Modal>

      <Modal
        isOpen={botConfirmModal}
        onClose={() => {
          setBotConfirmModal(false);
          setPendingBotAssignment(null);
          setRecruiter((prev) => ({ ...prev }));
        }}
        title="Confirm Bot Assignment"
        titleColor="primary"
        width="max-w-sm"
        zIndex={100}
      >
        <div className="flex flex-col gap-6 p-4 pt-2">
          <FormFieldSet
            type="number"
            title="Maximum calls"
            placeholder="Enter limit"
            value={maximumCalls}
            onChange={(value) => setMaximumCalls(value)}
          />
          <p className="text-gray-700">Are you sure you want to assign a bot recruiter to this job?</p>
          <div className="flex justify-end gap-3 outline-none">
            <Button
              variant="outlined"
              title="Cancel"
              onClick={() => {
                setBotConfirmModal(false);
                setPendingBotAssignment(null);
                setRecruiter((prev) => ({ ...prev }));
              }}
            />
            <Button
              title="Confirm"
              onClick={() => {
                setBotConfirmModal(false);
                if (pendingBotAssignment) {
                  handleRecruiterChange(pendingBotAssignment.newRecruiter, pendingBotAssignment.row, true);
                }
              }}
            />
          </div>
        </div>
      </Modal>

      {/* <Modal
        isOpen={statusChangeModal}
        onClose={() => setStatusChangeModal(false)}
        title={"Update Job Status"}
        titleColor={"primary"}
        width="max-w-sm"
      >
        <div className="flex flex-col gap-6 p-2">
          <FormFieldSet
            type="datepicker"
            title="Effective Date"
            placeholder="Select Date"
            value={statusChangeDate}
            onChange={(value) => setStatusChangeDate(value)}
          />
          <div className="flex justify-end gap-3">
            <Button
              variant="outlined"
              title="Cancel"
              onClick={() => {
                (setStatusChangeModal(false), setStatusChangeDate(null));
              }}
            />
            <Button
              title="Confirm"
              onClick={() => {
                (setStatusChangeModal(false), setStatusChangeDate(null));
              }}
            />
          </div>
        </div>
      </Modal> */}

      {/* Priority Leads Modal */}
      <Modal
        isOpen={leadCaptureModal}
        onClose={() => {
          if (!leadSubmitting) resetLeadModal();
        }}
        title={"Add to Leads"}
        titleColor={"primary"}
        width="max-w-md"
        showCloseButton={!leadSubmitting}
      >
        <div className="flex flex-col gap-5 p-2">
          <p className="text-sm text-gray-500">
            Please provide the details below to add this job to leads.
          </p>

          {/* Company Name */}
          <FormFieldSet
            title="Company Name"
            placeholder="Company name"
            value={leadCompanyName}
            disabled
          />

          {/* Show checking state */}
          {checkingCompany && (
            <p className="text-xs text-gray-400 animate-pulse">
              Checking if company already exists...
            </p>
          )}
          {!checkingCompany && companyAlreadyExists && (
            <div className="flex items-center gap-2 bg-green-50 border border-green-200 rounded-md px-3 py-2">
              <span className="material-symbols-outlined text-green-600 text-sm">
                check_circle
              </span>
              <p className="text-xs text-green-700 font-medium">
                {existingLeadJobUiid
                  ? "This job already exists in leads and will be updated with the new status."
                  : "This company already exists. This will be added under it."}
              </p>
            </div>
          )}

          {/* LinkedIn URL */}
          {!checkingCompany && !companyAlreadyExists && (
            <div className="flex flex-col gap-1">
              <FormFieldSet
                title="LinkedIn Company URL"
                placeholder="https://www.linkedin.com/company/your-company"
                value={leadLinkedInUrl}
                onChange={(val) => {
                  setLeadLinkedInUrl(val);
                  if (leadUrlError)
                    setLeadUrlError(validateLinkedInCompanyUrl(val));
                }}
                error={leadUrlError}
              />
            </div>
          )}

          {/* Assign To */}
          <FormFieldSet
            title="Assign To"
            placeholder={user?.data?.role?.type === 1 ? "Select" : ""}
            type="onlyBDMUsers"
            value={leadAssignedTo}
            showSearch
            disabled={user?.data?.role?.type === 3}
            onChange={(val) => {
              if (user?.data?.role?.type === 1) {
                setLeadAssignedTo(val);
              }
            }}
          />

          {[5, 6, 7].includes(leadCaptureStatus) && (
            <div className="flex flex-col gap-1">
              <FormFieldSet
                type="datepicker"
                title={
                  leadCaptureStatus === 5
                    ? "Interview L1 Date"
                    : leadCaptureStatus === 6
                      ? "Interview L2 Date"
                      : "Interview L3 Date"
                }
                placeholder="Select interview date"
                value={interviewDate}
                minDate={new Date()}
                onChange={(val) => {
                  setInterviewDate(val);
                  if (interviewDateError) {
                    setInterviewDateError(
                      validateInterviewDate(
                        val,
                        leadCaptureStatus,
                        leadCaptureRow?.statusHistory,
                      ),
                    );
                  }
                }}
                error={interviewDateError}
              />
              {interviewDateError && (
                <p className="text-xs text-red-500 mt-0.5">
                  {interviewDateError}
                </p>
              )}
              {leadCaptureStatus === 6 &&
                (() => {
                  const l1Entry = [...(leadCaptureRow?.statusHistory || [])]
                    .reverse()
                    .find((h) => h?.status === 5);
                  return l1Entry?.scheduledDate ? (
                    <p className="text-xs text-gray-400 mt-1">
                      L1 was scheduled on{" "}
                      <span className="font-medium text-gray-600">
                        {new Date(l1Entry.scheduledDate).toLocaleDateString(
                          "en-US",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          },
                        )}
                      </span>
                      . L2 must be after this date.
                    </p>
                  ) : null;
                })()}
              {leadCaptureStatus === 7 &&
                (() => {
                  const l2Entry = [...(leadCaptureRow?.statusHistory || [])]
                    .reverse()
                    .find((h) => h?.status === 6);
                  return l2Entry?.scheduledDate ? (
                    <p className="text-xs text-gray-400 mt-1">
                      L2 was scheduled on{" "}
                      <span className="font-medium text-gray-600">
                        {new Date(l2Entry.scheduledDate).toLocaleDateString(
                          "en-US",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          },
                        )}
                      </span>
                      . L3 must be after this date.
                    </p>
                  ) : null;
                })()}
            </div>
          )}

          <div className="flex justify-end gap-3 mt-2">
            <Button
              variant="outlined"
              title="Cancel"
              color="black"
              disabled={leadSubmitting || checkingCompany}
              onClick={resetLeadModal}
            />
            <Button
              title={leadSubmitting ? "Submitting..." : "Submit"}
              disabled={leadSubmitting || checkingCompany}
              onClick={handleLeadCaptureSubmit}
            />
          </div>
        </div>
        <Backdrop isOpen={leadSubmitting}>
          <LogoLoader />
        </Backdrop>
      </Modal>
    </div>
  );
};

export default AllJobs;
